import {Subtitle} from "@/models/Subtitle";
import {getUniqueCharacters} from "@/utils/font/characterUtils";
import {getDefaultFont, getSupportedFonts} from "@/services/googleFontsService";
import {calculateProportionalFontSize} from "@/models/SubtitleStyle";

export type FontInitializationResult = {
    subtitles: Subtitle[];
    availableFonts: string[];
};

export async function initializeSubtitleFonts(
    items: Subtitle[],
    videoHeight: number
): Promise<FontInitializationResult> {
    if (!items.length || !videoHeight) {
        return {subtitles: items, availableFonts: []};
    }

    const allChars = getUniqueCharacters(items.map(item => item.text));
    const supportedFonts = await getSupportedFonts(allChars, 0.85);
    const availableFonts = supportedFonts.map(el => el.font);

    if (!availableFonts.length) {
        return {subtitles: items, availableFonts: []};
    }

    const scaledFontSize = calculateProportionalFontSize(videoHeight);
    const defaultFont = getDefaultFont(availableFonts);

    const updatedSubtitles = items.map(item => {
        const style = item.style;
        if (style.fontSize && style.fontFamily) {
            return item;
        }

        const fontFamily = style.fontFamily || defaultFont;
        const updatedSubtitle = item.clone();
        updatedSubtitle.style = {
            ...style,
            fontSize: style.fontSize || scaledFontSize,
            fontFamily
        };
        return updatedSubtitle;
    });

    return {
        subtitles: updatedSubtitles,
        availableFonts
    };
}
